export default __webpack_public_path__ + "static/media/Shawl of the Departed.12138272.jpg";